import { getFullUploadUrl } from '../config/environment';

let avatarCacheBuster = Date.now();

export const refreshAvatarCache = () => {
  avatarCacheBuster = Date.now();
};

export const isDefaultAvatar = (avatarUrl: string | null | undefined): boolean => {
  return !avatarUrl || avatarUrl === 'default' || avatarUrl === 'asset:/assets/images/logo-no-text.png';
};

export const getAvatarUrl = (avatarUrl: string | null | undefined): string => {
  if (!avatarUrl || isDefaultAvatar(avatarUrl)) return '';
  if (avatarUrl.startsWith('http')) return avatarUrl;
  return `${getFullUploadUrl(avatarUrl)}?t=${avatarCacheBuster}`;
};
